// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GetSiteAccountsResponseModel } from './getSiteAccountsResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AdminAdminGetSiteAccountsDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': GetSiteAccountsResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AdminAdminGetSiteAccountsDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "GetSiteAccountsResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return AdminAdminGetSiteAccountsDefaultResponse.attributeTypeMap;
    }
}
